<template>
  <div class="_plan_item">
    <div class="_plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <p class="_plan_item_title">
      <span class="blink2 fs4">【彩霸王】 {{ data.title }}</span>
    </p>
    <ul class="fs3">
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">
          {{ el.qiShu }}期：
          <span class="winText" v-if="el.ifZuiXin">等开</span>
          <span class="winText" v-else
            >开：{{ getNumSx(el.code, el.qiShu) }} {{ el.code
            }}{{ el.ifWin ? "准" : "错" }}</span
          >
        </div>
        <div :class="{ suck: !el.ifWin && !el.ifZuiXin }">
          <span class="value" v-if="typeof el.yuCe == 'string'">
            <span :class="{ win: el.ifWin }">{{ el.yuCe }}</span> 】
          </span>
          <span class="value fs4" v-else>
            <span
              :class="{ win: num.ifWin }"
              v-for="(num, numIndex) in el.ifZuiXin ? el.yuCe : el.shuXingList"
              :key="numIndex"
              >{{ num.yuCe || num
              }}<span v-if="numIndex < el.yuCe.length - 1">.</span>
            </span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";
import { getNumSx } from "../../utils/index";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #fff !important;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
._plan_item {
  border: 1px solid #009788;
  ._plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  ._plan_item_title {
    font-weight: bold;
    text-align: center;
    background: #3e73fe;
    padding: 16px 0;
    color: #fff;
    border-radius: 12px 12px 0 0;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    border-radius: 12px;
    overflow: hidden;
    margin-top: -6px;
    li {
      text-align: center;
      padding: 5px 18px;
      font-weight: bold;
      justify-content: center;
      .value {
        color: red;
        word-break: break-all;
        .win {
          background-color: #ffff00;
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>